// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { getResultCount } from '../../../store/assortment';
import { getResultTitle, getResultTitlePlural, getAssortmentCategoryTitle } from '../../../store/assortmentSettings';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';
import Title from '../../title';

type StateProps = {|
  assortmentCategoryTitle: string,
  count: number,
  resultTitle: string,
  resultTitlePlural: string,
|};

type Props = StateProps;

const SubTitle = styled<any, Theme>('p')`
  font-size: 1.5rem;
  color: ${props => props.theme.assortment.resultCount.subtitleColor};
`;

const Container = styled<any, Theme>('div')`
  padding: 0.5rem 0.5rem 3.5rem 0.5rem;
  display: none;

  ${media.lg(css`
    display: block;
  `)}
`;

const ResultCount = ({
  assortmentCategoryTitle,
  count,
  resultTitle,
  resultTitlePlural,
}: Props) => (
  <Container>
    <Title>
      {count}
      {' '}
      {count === 1 ? resultTitle : resultTitlePlural}
    </Title>
    <SubTitle>{assortmentCategoryTitle}</SubTitle>
  </Container>
);

const mapStateToProps = (state): StateProps => ({
  assortmentCategoryTitle: getAssortmentCategoryTitle(state),
  count: getResultCount(state),
  resultTitle: getResultTitle(state),
  resultTitlePlural: getResultTitlePlural(state),
});

export default connect<any, any, StateProps, any, any, any>(
  mapStateToProps,
)(ResultCount);
